import React, { useState } from "react";
import "./_header.scss";

function Header() {
  const [menuActive, setMenuActive] = useState(false);

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  const closeMenu = () => {
    setMenuActive(false);
  };

  const menuBtnClass = menuActive ? "menu-btn active" : "menu-btn";
  const navigationClass = menuActive ? "navigation active" : "navigation";

  return (
    <header>
      <h1 className="brand">Matthieu</h1>
      <div className={menuBtnClass} onClick={toggleMenu}></div>
      <div className={navigationClass}>
        <a href="#main" onClick={closeMenu}>Home</a>
        <a href="#about" onClick={closeMenu}>About</a>
        <a href="#skills" onClick={closeMenu}>Skills</a>
        <a href="#work" onClick={closeMenu}>Work</a>
        <a href="#contact" onClick={closeMenu}>Contact</a>
      </div>
    </header>
  );
}

export default Header;
